<template>
  <div  :class="{'english': isenglish ,'japanese': isjapanese ,'order_style':true}">
    <div class="or_style">
      <PcUserLeft />
      <div class="center_layout_style">
        <UserConfig v-if="leftItem == 1" />
        <UserFamily v-if="leftItem == 2" />
        <Order v-if="leftItem == 3" />
        <UserAddress v-if="leftItem == 4" />
        <!-- <MobileOrder /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import PcUserLeft from "./PcUserLeft.vue";
import MobileOrder from "./MobileOrder.vue";
import UserConfig from "../views/UserConfig.vue";
import UserFamily from "../views/UserFamily.vue";
import Order from "../views/Order.vue";
import UserAddress from "../views/UserAddress.vue";
export default {
  computed: {
    ...mapState(["cgmUserVO", "leftItem", "mobile"]),
  },
  components: {
    PcUserLeft,
    MobileOrder,
    UserConfig,
    UserFamily,
    Order,
    UserAddress,
  },
  data() {
    return {
      size: 300,
      nihaopay_qr_code: null,
      payDialogVisible: false,
      order_list: [],
      centerDialogVisible: false,
      track_list: [],
      item: null,
      isenglish:false,
      isjapanese:false
    };
  },
  mounted() {
    // this.cgmOrderList();
    // const ua = navigator.userAgent.toLowerCase();
    // console.log("isMobile", /phone|mobile|android|iphone|ipad|ipod/i.test(ua));
    // this.setMobile(/phone|mobile|android|iphone|ipad|ipod/i.test(ua));
    // this.language = window.translate.language.getCurrent();
    // if(this.language == "english"){
    //   this.isenglish = true
    // }
    // if(this.language == "japanese"){
    //   this.isjapanese = true
    // }
  },
  methods: {
    ...mapMutations(["setCgmUserVO", "setLeftItem", "setMobile"]),
    cgmOrderList() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .get("/cgmOrder/getOrderByUserId", {
          params: {
            userId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.order_list = res.data.data;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.center_layout_style {
  width: 70%;
  padding: 40px;
  background: #fff;
  border-radius: 11px;
}
@media (max-width:768px) {
  ::v-deep .el-dialog {
    width: 100% !important;
  }
  .media_style1 {
    display: none;
  }
  .order_style {
    padding: unset !important;
    background: unset !important;
  }
  .center_layout_style {
    width: unset !important;
    padding: 40px 0 !important;
  }
}
@media (min-width:768px) {
  .mobile_hide_style {
    display: none;
  }
}
.order_style {
  padding: 40px 0;
  background: #f5f6f7;
  display: flex;
  justify-content: center;
}
.or_style {
  width: 87%;
  display: flex;
  gap: 4%;
}
.detail_style {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.o_style {
  margin-right: 10px;
  cursor: pointer;
}
.card_style {
  margin-bottom: 10px;
}
.repay_style {
  cursor: pointer;
}
.repay_style1 {
  color: #f56c6c;
}
.pa_style {
  display: flex;
  justify-content: space-around;
}
.pa1_style {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 20px;
}
.pa2_style {
  display: flex;
  // justify-content: flex-end;
  align-items: center;
  gap: 10px;
  // margin-bottom: 20px;
}
.order_head {
  display: flex;
  justify-content: space-between;
}
.qr_style {
  display: flex;
  justify-content: center;
}
.english {
  // .
}
.japanese {
}
</style>